import { Editor } from "@tinymce/tinymce-react";
import { forwardRef } from "react";

const CustomEditor = forwardRef((props, ref) => {
  return (
    <Editor
      ref={ref}
      apiKey="clkjy0xkxffeddiszf8tf6pw0937osrzu0n8sa3yghjofi8d"
      init={{
        valid_elements: "*[*]",
        plugins:
          "anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount checklist mediaembed casechange export formatpainter pageembed linkchecker a11ychecker tinymcespellchecker permanentpen powerpaste advtable advcode editimage advtemplate ai mentions tinycomments tableofcontents footnotes mergetags autocorrect typography inlinecss markdown",
        toolbar:
          "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat",
        tinycomments_mode: "embedded",
        tinycomments_author: "Author name",
        mergetags_list: [
          // { value: "First.Name", title: "First Nam100%
          { value: "Email", title: "Email" },
        ],
        ai_request: (request, respondWith) =>
          respondWith.string(() =>
            Promise.reject("See docs to implement AI Assistant")
          ),
        height: "100%",
        width: "100%",
        automatic_uploads: true,
        // images_upload_handler(blobInfo, progress) {
        //   console.log(blobInfo);
        //   progress(22);
        //   return ;
        // },
        file_picker_callback(callback, value, meta) {
          // Create an input element
          let input = document.createElement("input");
          input.setAttribute("type", "file");
          input.setAttribute("accept", "image/*");

          // Listen for file selection
          input.onchange = function () {
            let file = input.files[0];

            // Use FileReader to read the image as a data URL
            let reader = new FileReader();
            reader.onload = function (e) {
              // Pass the image URL to the callback function
              callback(e.target.result, { alt: file.name });
            };

            reader.readAsDataURL(file);
          };
          // Trigger the file input click
          input.click();
        },
      }}
      {...props}
    />
  );
});

export default CustomEditor;
